import { globalStore, toRaw } from "@/BaseComponent";

export const setOption = (chartOption: any) => {
    const selectOption = toRaw(chartOption);
    const global = globalStore();
    const Cdata = selectOption.data;

    let chartData = [] as Array<any>;

    switch (global.chart) {
        case "line":
            if (Cdata.data.length > 1) {
                chartData = Cdata.legend.map((name: any, idx: number) => ({
                    name: name,
                    type: global.chart,
                    symbolSize: 0,
                    data: Cdata.data[idx],
                    label: {
                        show: false,
                        position: "top",

                        fontSize: 13,
                    },
                }));
            } else {
                chartData = Cdata.data.map((data: any, idx: number) => ({
                    name: Cdata.legend[idx],
                    type: global.chart,
                    symbolSize: 0,
                    data: data,
                    label: {
                        show: false,
                        position: "top",

                        fontSize: 13,
                    },
                }));
            }
            break;
        case "bar":
            if (Cdata.data.length > 1) {
                chartData = Cdata.legend.map((item: string, idx: number) => ({
                    name: item,
                    type: "bar",
                    barGap: 0,
                    emphasis: {
                        focus: "series",
                    },
                    data: Cdata.data[idx],
                }));
            } else {
                chartData = [
                    {
                        data: Cdata.data[0],
                        type: "bar",
                        label: {
                            show: true,
                            formatter: "{b}\n{c}",

                            fontSize: 25,
                        },
                    },
                ];
            }
            break;
        case "pie":
            if (Cdata.data.length > 1) {
                chartData = Cdata.category.map((item: string, index: number) => ({
                    name: item,
                    type: "pie",
                    center: [index * 18 + 15 + "%", "50%"], // Adjusting center for each pie
                    radius: "30%",
                    data: Cdata.legend.map((subItem: string, subIndex: number) => ({
                        name: subItem,
                        value: Cdata.data[index][subIndex],
                    })),
                }));
            } else {
                chartData = [
                    {
                        name: "Access From",
                        type: "pie",
                        radius: "55%",
                        symbolSize: 8,
                        data: Cdata.legend.map((data: any, idx: number) => ({ value: Cdata.data[0][idx], name: data })),
                        emphasis: {
                            label: {
                                formatter: "{b}: {c}",
                                position: "inside",

                                fontSize: 20,
                            },
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                        lavelLayout: {},
                        label: {
                            show: true,
                            position: "outside",
                        },
                    },
                ];
            }
            break;
        case "donut":
            if (Cdata.data.length > 1) {
                chartData = Cdata.category.map((item: string, index: number) => ({
                    name: item,
                    type: "pie",
                    center: [index * 18 + 15 + "%", "50%"], // Adjusting center for each pie
                    radius: ["10%", "30%"],
                    data: Cdata.legend.map((subItem: string, subIndex: number) => ({
                        name: subItem,
                        value: Cdata.data[index][subIndex],
                    })),
                }));
            } else {
                chartData = [
                    {
                        name: "Access From",
                        type: "pie",
                        radius: ["30%", "55%"],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderRadius: 10,
                            borderColor: "#fff",
                            borderWidth: 2,
                        },
                        label: {
                            show: true,
                            position: "left",
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 40,
                                fontWeight: "bold",
                            },
                        },
                        labelLine: {
                            show: false,
                        },
                        data: Cdata.legend.map((data: Array<Array<number>>, idx: number) => ({ value: Cdata.data[0][idx], name: data })),
                    },
                ];
            }
            break;
        case "test1":
            chartData = [
                {
                    name: Cdata.legend[0],
                    type: "candlestick",
                    data: Cdata.data.map(([value1, value2]: number[][]) => [value1, value2, value1, value2]),
                    itemStyle: {
                        color: "green", // 상승 시 색상
                        color0: "green", // 하락 시 색상
                        borderColor: "green", // 상승 시 테두리 색상
                        borderColor0: "green", // 하락 시 테두리 색상
                    },
                },
            ];
            break;
        default:
            break;
    }

    //차트 설정 공통 부분
    const defaultOption = {
        xAxis: {
            show: true,
            type: "category",
            data: Cdata.category,
            axisLabel: {
                interval: "auto", // 4개마다 1개만 표시
            },
        },
        yAxis: {
            type: "value",
        },

        grid:
            global.chart === "pie" || global.chart === "donut"
                ? {
                      right: "2%",
                      left: "5%",
                  }
                : {
                      left: "2%",
                      top: "15%",
                      right: "0%",
                      bottom: "15%",
                  },
        title: {
            text: selectOption.title || "Chart",
            subtext: selectOption.subTitle || null,
            padding: selectOption.titlePadding.length === 0 ? 0 : selectOption.titlePadding,
        },
        tooltip: {
            trigger: "axis",
            formatter: "{b} {c}명",
        },
        toolbox:
            global.chart === "bar"
                ? {
                      show: true,
                      orient: "vertical",
                      left: "right",
                      top: "center",
                      feature: {
                          mark: { show: true },
                          magicType: { show: true, type: ["line", "bar", "stack"] },
                          restore: { show: true },
                          saveAsImage: { show: true },
                      },
                  }
                : {},
        legend: {
            left: selectOption.legendPosition === "left" || selectOption.legendPosition === "" ? "auto" : "38%",
            top: selectOption.legendPosition === "left" || selectOption.legendPosition === "" ? "30%" : "90%",
            orient: selectOption.legendPosition === "left" || selectOption.legendPosition === "" ? "vertical" : "horizontal",
            data: selectOption.legendContent,
            show: global.chart === "line" ? false : true,
        },
        series: chartData,
    };

    return defaultOption;
};
